exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mf_title{font-weight:700;font-size:2em}.mf_title_bl{font-weight:700;font-size:2em;font:var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-70)/var(--unnamed-line-spacing-89) var(--unnamed-font-family-dosis);letter-spacing:var(--unnamed-character-spacing-0);color:var(--unnamed-color-ffffff);text-align:left;font:normal normal 700 70px/89px Dosis;letter-spacing:0;color:#fff;opacity:1}", ""]);

// exports
